import { NetworkState } from "./types";

export interface MobxLifecycleStateInput {
  isLoading: boolean;
  hasError: boolean;
}

export function resolveNetworkState(input: MobxLifecycleStateInput): NetworkState {
  const { isLoading, hasError } = input;
  if (hasError) return NetworkState.Error;
  if (isLoading) return NetworkState.Loading;
  return NetworkState.Success;
}
